import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTwitter, faLinkedin, faFacebook, faInstagram
} from '@fortawesome/free-brands-svg-icons';
import { FooterContainer, FooterContent, WazaFooter } from './SharedStyles';

function Footer() {
  const { t } = useTranslation();

  return (
    <FooterContainer>
      <FooterContent>
        <div>
          <h4>{t('footer.connect')}</h4>
          <ul>
            <li><a href="#twitter" id="footer-twitter-016"><FontAwesomeIcon icon={faTwitter} /> Twitter</a></li>
            <li><a href="#linkedin" id="footer-linkedin-017"><FontAwesomeIcon icon={faLinkedin} /> LinkedIn</a></li>
            <li><a href="#facebook" id="footer-facebook-018"><FontAwesomeIcon icon={faFacebook} /> Facebook</a></li>
            <li><a href="#instagram" id="footer-instagram-019"><FontAwesomeIcon icon={faInstagram} /> Instagram</a></li>
          </ul>
        </div>
      </FooterContent>
      <WazaFooter>
        <p>Built with <span className="heart">&#9829;</span> by <span className="waza-highlight">WAZA</span></p>
        <p>We are <span className="waza-highlight">WAZA</span>. And we are coding a easier world.</p>
      </WazaFooter>
    </FooterContainer>
  );
}

export default Footer;
